module.exports = __webpack_public_path__ + "static/media/39.c376f08d.mp3";